document.addEventListener('DOMContentLoaded', () => {
  const breakpoint_lg = window.matchMedia('(min-width: 992px)');
  const product_detail_images = document.getElementById('product-detail-images');
  const product_detail_images_zoom = document.getElementById('product-detail-images-zoom');
  const product_detail_info = document.getElementById('product-detail-info');
  function resizeProductDetailImagesZoom(){
    product_detail_images_zoom.style.height = product_detail_images.querySelector('.carousel-inner').offsetHeight + 'px';
    product_detail_images_zoom.style.width = (product_detail_info.offsetWidth - 20) + 'px';
    product_detail_images_zoom.style.marginLeft = '10px';
    product_detail_images_zoom.style.marginRight = '10px';
  }
  resizeProductDetailImagesZoom();
  window.addEventListener('resize', resizeProductDetailImagesZoom);

  function zoomInMouseEnter(/** @type MouseEvent */ e) {
    product_detail_images_zoom.style.display = 'block';
    const firstImage = product_detail_images.querySelector('img');
    const firstImageSrc = firstImage.currentSrc;
    if(firstImageSrc.includes('.avif')){
      product_detail_images_zoom.style.backgroundImage = `url(${this.dataset.zoomAvif})`;
    } else if (firstImageSrc.includes('.webp')) {
      product_detail_images_zoom.style.backgroundImage = `url(${this.dataset.zoomWebp})`;
    } else {
      product_detail_images_zoom.style.backgroundImage = `url(${this.dataset.zoomFallback})`;
    }
    product_detail_images_zoom.style.backgroundRepeat = 'no-repeat';
  }
  function zoomInMouseMove(/** @type MouseEvent */ e) {
    const position = {
      y: Math.round(e.offsetY / this.offsetHeight * 100),
      x: Math.round(e.offsetX / this.offsetWidth * 100),
    }
    product_detail_images_zoom.style.backgroundPositionX = position.x + '%';
    product_detail_images_zoom.style.backgroundPositionY = position.y + '%';
  }
  function zoomInMouseLeave() {
    product_detail_images_zoom.style.display = 'none';
    product_detail_images_zoom.style.backgroundImage = 'unset';
    product_detail_images_zoom.style.backgroundPositionX = '';
    product_detail_images_zoom.style.backgroundPositionY = '';
  }

  const zoom_ins = product_detail_images.querySelectorAll('.cursor-lg-zoom-in');
  function enableZoom() {
    zoom_ins.forEach((/** @type HTMLPictureElement */ z) => {
      z.addEventListener('mouseenter', zoomInMouseEnter);
      z.addEventListener('mousemove', zoomInMouseMove);
      z.addEventListener('mouseleave', zoomInMouseLeave);
    });
  }
  function disableZoom() {
    zoom_ins.forEach((/** @type HTMLPictureElement */ z) => {
      z.removeEventListener('mouseenter', zoomInMouseEnter);
      z.removeEventListener('mousemove', zoomInMouseMove);
      z.removeEventListener('mouseleave', zoomInMouseLeave);
      zoomInMouseLeave();
    });
  }

  if(breakpoint_lg.matches) {
    enableZoom();
  }
  breakpoint_lg.addEventListener('change', (ev) => {
    if(ev.matches) {
      enableZoom();
      return;
    }
    disableZoom();
  })
});